// @ts-nocheck
import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// import { useParams } from "react-router-dom";
import { GetAbsenceAttendanceView } from '@store/HR/Person/absenceSlice';
import Loading from '@components/Shared/Loader/Loading';

// const ViewAbsence = ({ ReferenceId }) => {
//   const { t, i18n } = useTranslation();

//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (ReferenceId) {
//       dispatch(GetAbsenceAttendanceView(ReferenceId));
//     }
//   }, [ReferenceId, dispatch]);

//   const data = useSelector(state => state.Absence?.AbsenceAttendanceViewList?.data);
//   const loading = useSelector(state => state.Absence.loading2);
//   const error = useSelector(state => state.Absence.error2);

//   return (
//     <>
//       <Loading loading={loading} error={error}>
//         <div className='row m-0'>
//           <div className='col-xl-12'>
//             <table className='table table-bordered'>
//               <tbody>
//                 <tr>
//                   <th className='bg-theme bg-opacity-25' style={{ maxWidth: '50px', textAlign: 'center' }}>
//                     {t('Absence_Type')}
//                   </th>
//                   <td>{i18n.language === 'ar' ? data?.absenceName2 : data?.absenceName}</td>
//                 </tr>

//                 <tr>
//                   <th
//                     colSpan={1}
//                     scope='row'
//                     className='bg-theme bg-opacity-25'
//                     style={{ maxWidth: '50px', textAlign: 'center' }}
//                   >
//                     {t('Start Date')}
//                   </th>
//                   <td colSpan={4}>{data?.dateStart}</td>
//                 </tr>

//                 <tr>
//                   <th
//                     colSpan={1}
//                     scope='row'
//                     className='bg-theme bg-opacity-25 '
//                     style={{ maxWidth: '50px', textAlign: 'center' }}
//                   >
//                     {t('Date_TO')}
//                   </th>
//                   <td colSpan={4}>{data?.dateEnd}</td>
//                 </tr>

//                 <tr>
//                   <th
//                     colSpan={1}
//                     scope='row'
//                     className='bg-theme bg-opacity-25'
//                     style={{ maxWidth: '50px', textAlign: 'center' }}
//                   >
//                     {t('Days')}
//                   </th>
//                   <td colSpan={4}>{data?.absenceDays}</td>
//                 </tr>

//                 <tr>
//                   <th
//                     colSpan={1}
//                     scope='row'
//                     className='bg-theme bg-opacity-25'
//                     style={{ maxWidth: '50px', textAlign: 'center' }}
//                   >
//                     {t('Authorising_Person')}
//                   </th>
//                   <td colSpan={4}>{i18n.language === 'ar' ? data?.authorisingName2 : data?.authorisingName}</td>
//                 </tr>

//                 <tr>
//                   <th
//                     colSpan={1}
//                     scope='row'
//                     className='bg-theme bg-opacity-25'
//                     style={{ maxWidth: '50px', textAlign: 'center' }}
//                   >
//                     {t('replacement')}
//                   </th>
//                   <td colSpan={4}>{i18n.language === 'ar' ? data?.replacemenName2 : data?.replacemenName}</td>
//                 </tr>

//                 <tr>
//                   <th
//                     colSpan={1}
//                     scope='row'
//                     className='bg-theme bg-opacity-25'
//                     style={{ maxWidth: '50px', textAlign: 'center' }}
//                   >
//                     {t('Notes')}
//                   </th>
//                   <td colSpan={4}>{data?.comments}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

const ViewAbsence = ({ ReferenceId }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (ReferenceId) {
      dispatch(GetAbsenceAttendanceView(ReferenceId));
    }
  }, [ReferenceId, dispatch]);

  const data = useSelector(state => state.Absence?.AbsenceAttendanceViewList?.data);
  const loading = useSelector(state => state.Absence.loading2);
  const error = useSelector(state => state.Absence.error2);

  return (
    <Loading loading={loading} error={error}>
      <>
        {!data && (
          <div className='alert alert-warning m-3'>
            <div className='d-flex align-items-center'>
              <i className='fa fa-info-circle fa-lg me-3'></i>
              <div>
                <h6 className='alert-heading mb-1'>{t('NoData')}</h6>
                <p className='mb-0'>{t('NoAbsenceDataFound')}</p>
              </div>
            </div>
          </div>
        )}
        <div className='p-3'>
          <div className='row'>
            <div className='col-xl-12'>
              <div className='card shadow-sm border-0'>
                <div className='card-header bg-theme text-white py-3'>
                  <div className='d-flex align-items-center'>
                    <i className='fa fa-calendar-alt fa-lg me-2'></i>
                    <h5 className='mb-0'>{t('AbsenceDetails')}</h5>
                  </div>
                </div>

                <div className='card-body p-0'>
                  <div className='table-responsive'>
                    <table className='table table-hover mb-0'>
                      <tbody>
                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold' style={{ width: '200px' }}>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-tag fa-fw me-2'></i>
                              {t('Absence_Type')}
                            </div>
                          </th>
                          <td className='fw-medium'>
                            {i18n.language === 'ar' ? data?.absenceName2 : data?.absenceName}
                          </td>
                        </tr>

                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-calendar-plus fa-fw me-2'></i>
                              {t('Start Date')}
                            </div>
                          </th>
                          <td>
                            <span className='badge bg-primary bg-opacity-10 text-primary px-3 py-2'>
                              {data?.dateStart}
                            </span>
                          </td>
                        </tr>

                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-calendar-minus fa-fw me-2'></i>
                              {t('Date_TO')}
                            </div>
                          </th>
                          <td>
                            <span className='badge bg-primary bg-opacity-10 text-primary px-3 py-2'>
                              {data?.dateEnd}
                            </span>
                          </td>
                        </tr>

                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-clock fa-fw me-2'></i>
                              {t('Days')}
                            </div>
                          </th>
                          <td>
                            <span className='badge bg-theme px-3 py-2 fs-6'>
                              {data?.absenceDays} {t('Days')}
                            </span>
                          </td>
                        </tr>

                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-user-check fa-fw me-2'></i>
                              {t('Authorising_Person')}
                            </div>
                          </th>
                          <td className='fw-medium'>
                            {data?.authorisingName ? (
                              i18n.language === 'ar' ? (
                                data.authorisingName2
                              ) : (
                                data.authorisingName
                              )
                            ) : (
                              <span className='text-muted'>{t('NotSpecified')}</span>
                            )}
                          </td>
                        </tr>

                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-user-clock fa-fw me-2'></i>
                              {t('replacement')}
                            </div>
                          </th>
                          <td className='fw-medium'>
                            {data?.replacemenName ? (
                              i18n.language === 'ar' ? (
                                data.replacemenName2
                              ) : (
                                data.replacemenName
                              )
                            ) : (
                              <span className='text-muted'>{t('NotSpecified')}</span>
                            )}
                          </td>
                        </tr>

                        <tr className='align-middle'>
                          <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                            <div className='d-flex align-items-center'>
                              <i className='fa fa-sticky-note fa-fw me-2'></i>
                              {t('Notes')}
                            </div>
                          </th>
                          <td>
                            {data?.comments ? (
                              <div className='bg-secondary bg-opacity-40 rounded p-3 border'>{data.comments}</div>
                            ) : (
                              <span className='text-muted'>{t('NoNotes')}</span>
                            )}
                          </td>
                        </tr>

                        {/* حالة الطلب إذا كانت متوفرة */}
                        {data?.status && (
                          <tr className='align-middle'>
                            <th className='bg-secondary bg-opacity-40 text-theme fw-semibold'>
                              <div className='d-flex align-items-center'>
                                <i className='fa fa-info-circle fa-fw me-2'></i>
                                {t('Status')}
                              </div>
                            </th>
                            <td>
                              <span
                                className={`badge ${
                                  data.status === 'Approved'
                                    ? 'bg-success'
                                    : data.status === 'Rejected'
                                    ? 'bg-danger'
                                    : 'bg-warning'
                                } px-3 py-2 fs-6`}
                              >
                                {data.status === 'Approved'
                                  ? t('Approved')
                                  : data.status === 'Rejected'
                                  ? t('Rejected')
                                  : t('Pending')}
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </Loading>
  );
};

export default ViewAbsence;
